exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-box .el-row[data-v-759859ee] {\n  margin-bottom: 10px;\n}\n.my-box .el-row[data-v-759859ee]:last-child {\n    margin-bottom: 0;\n}\n.my-box .el-col[data-v-759859ee] {\n  border-radius: 4px;\n}\n", ""]);

// exports
